import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/styles';

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '& .no-rows-primary': {
    fill: '#3D4751',
    ...theme.applyStyles('light', {
      fill: '#AEB8C2',
    }),
  },
  '& .no-rows-secondary': {
    fill: '#1D2126',
    ...theme.applyStyles('light', {
      fill: '#E8EAED',
    }),
  },
}));

export function CustomNoRowsOverlay({ title, text, noRowsIconType, onGoBack }) {
  const renderIcon = () => {
    if (noRowsIconType === 'studies') {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="81"
          viewBox="0 0 80 81"
          fill="none"
        >
          <rect y="0.5" width="80" height="80" rx="40" fill="#F2F2F2" />
          <mask
            id="mask0_1704_30856"
            maskUnits="userSpaceOnUse"
            x="24"
            y="24"
            width="32"
            height="33"
          >
            <rect x="24" y="24.5" width="32" height="32" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_1704_30856)">
            <path
              d="M30.6667 52.5C29.9333 52.5 29.3056 52.2389 28.7833 51.7167C28.2611 51.1944 28 50.5667 28 49.8333V31.1667C28 30.4333 28.2611 29.8056 28.7833 29.2833C29.3056 28.7611 29.9333 28.5 30.6667 28.5H49.3333C50.0667 28.5 50.6944 28.7611 51.2167 29.2833C51.7389 29.8056 52 30.4333 52 31.1667V49.8333C52 50.5667 51.7389 51.1944 51.2167 51.7167C50.6944 52.2389 50.0667 52.5 49.3333 52.5H30.6667ZM33.3333 47.1667H42.6667V44.5H33.3333V47.1667ZM33.3333 41.8333H46.6667V39.1667H33.3333V41.8333ZM33.3333 36.5H46.6667V33.8333H33.3333V36.5Z"
              fill="#7D5AE8"
            />
          </g>
        </svg>
      );
    } else if (noRowsIconType === 'participants') {
      return (
        <svg
          width="80"
          height="81"
          viewBox="0 0 80 81"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.5" width="80" height="80" rx="40" fill="#F2F2F2" />
          <mask
            id="mask0_3214_107381"
            // eslint-disable-next-line react/no-unknown-property
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="24"
            y="24"
            width="32"
            height="33"
          >
            <rect x="24" y="24.5" width="32" height="32" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3214_107381)">
            <path
              d="M48.6312 41.0588C48.233 39.8644 47.2958 38.9271 46.1013 38.529L43.9987 37.8281L46.1013 37.1272C47.2958 36.7291 48.233 35.7918 48.6312 34.5974L49.332 32.4948L50.0329 34.5974C50.431 35.7918 51.3683 36.7291 52.5627 37.1272L54.6654 37.8281L52.5627 38.529C51.3683 38.9271 50.431 39.8644 50.0329 41.0588L49.332 43.1615L48.6312 41.0588ZM35.9987 40.4948C34.532 40.4948 33.2765 39.9726 32.232 38.9281C31.1876 37.8837 30.6654 36.6281 30.6654 35.1615C30.6654 33.6948 31.1876 32.4392 32.232 31.3948C33.2765 30.3503 34.532 29.8281 35.9987 29.8281C37.4654 29.8281 38.7209 30.3503 39.7654 31.3948C40.8098 32.4392 41.332 33.6948 41.332 35.1615C41.332 36.6281 40.8098 37.8837 39.7654 38.9281C38.7209 39.9726 37.4654 40.4948 35.9987 40.4948ZM25.332 51.1615V47.4281C25.332 46.6726 25.5265 45.9781 25.9154 45.3448C26.3043 44.7115 26.8209 44.2281 27.4654 43.8948C28.8431 43.2059 30.2431 42.6892 31.6654 42.3448C33.0876 42.0003 34.532 41.8281 35.9987 41.8281C37.4654 41.8281 38.9098 42.0003 40.332 42.3448C41.7543 42.6892 43.1543 43.2059 44.532 43.8948C45.1765 44.2281 45.6931 44.7115 46.082 45.3448C46.4709 45.9781 46.6654 46.6726 46.6654 47.4281V51.1615H25.332ZM27.9987 48.4948H43.9987V47.4281C43.9987 47.1837 43.9376 46.9615 43.8154 46.7615C43.6931 46.5615 43.532 46.4059 43.332 46.2948C42.132 45.6948 40.9209 45.2448 39.6987 44.9448C38.4765 44.6448 37.2431 44.4948 35.9987 44.4948C34.7543 44.4948 33.5209 44.6448 32.2987 44.9448C31.0765 45.2448 29.8654 45.6948 28.6654 46.2948C28.4654 46.4059 28.3043 46.5615 28.182 46.7615C28.0598 46.9615 27.9987 47.1837 27.9987 47.4281V48.4948ZM35.9987 37.8281C36.732 37.8281 37.3598 37.567 37.882 37.0448C38.4043 36.5226 38.6654 35.8948 38.6654 35.1615C38.6654 34.4281 38.4043 33.8003 37.882 33.2781C37.3598 32.7559 36.732 32.4948 35.9987 32.4948C35.2654 32.4948 34.6376 32.7559 34.1154 33.2781C33.5931 33.8003 33.332 34.4281 33.332 35.1615C33.332 35.8948 33.5931 36.5226 34.1154 37.0448C34.6376 37.567 35.2654 37.8281 35.9987 37.8281Z"
              fill="#7D5AE8"
            />
          </g>
        </svg>
      );
    }
    return null;
  };

  return (
    <StyledGridOverlay>
      <Box sx={{ width: 100, height: 100 }}>{renderIcon()}</Box>
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Typography mb={1} variant="h6">
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {text}
        </Typography>
        {onGoBack && (
          <Box mt={2}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={onGoBack}
              sx={{ textTransform: 'none' }}
            >
              Go Back
            </Button>
          </Box>
        )}
        {/* {type && (
          <Box my={3} display={'flex'} gap={1}>
            <Button size="large" variant="contained" onClick={handleCreate}>
              Create {type == 'survey' ? 'Survey' : 'Interview'}
            </Button>
            <Button size="large" variant="custom" onClick={handleUpload}>
              Upload Your Data
            </Button>
          </Box>
        )} */}
      </Box>
    </StyledGridOverlay>
  );
}
